"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPlatform = void 0;
var SubscriptionPlatform;
(function (SubscriptionPlatform) {
    SubscriptionPlatform["UNKNOWN"] = "unknown";
    SubscriptionPlatform["IOS"] = "ios";
    SubscriptionPlatform["ANDROID"] = "android";
    SubscriptionPlatform["PROMOTIONAL"] = "promotional";
    SubscriptionPlatform["WEB"] = "web";
})(SubscriptionPlatform || (exports.SubscriptionPlatform = SubscriptionPlatform = {}));
